export var INPUT_PHONE_MASK = '000 000-00-00';
export var INPUT_PHONE_MASK_MOBILE = '(000) 000-00-00';